import { Check, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";

export const PLAN_CARDS = [
  { key: "starter", name: "Starter", monthly: 19, yearly: 190, blurb: "For a single corporation getting organized.",
    features: ["1 Entity", "500 Receipts", "Compliance Dashboard", "Filing Calendar", "Basic Alerts"] },
  { key: "professional", name: "Professional", monthly: 49, yearly: 490, popular: true, blurb: "Everything an owner needs to stay in good standing.",
    features: ["5 Entities", "Unlimited Receipts", "Tax Tracking", "Document Vault", "AI Assistant", "Revival Workflows"] },
  { key: "operator", name: "Operator", monthly: 99, yearly: 990, blurb: "For holding companies and multi-entity groups.",
    features: ["25 Entities", "Multi-Company Dashboard", "Portfolio Health Score", "Team Access", "Priority Support", "Advanced AI Compliance"] },
  { key: "enterprise", name: "Enterprise", custom: true, blurb: "For firms, family offices and advisors.",
    features: ["Unlimited Entities", "Custom Integrations", "Account Manager", "White Label Options"] },
];

export const IntervalToggle = ({ interval, setInterval }) => (
  <div className="inline-flex rounded-full border border-border p-1 bg-card" data-testid="billing-interval-toggle">
    {["monthly", "yearly"].map((i) => (
      <button key={i} onClick={() => setInterval(i)} data-testid={`interval-${i}`}
        className={`px-4 py-1.5 text-sm rounded-full transition-colors ${interval === i ? "bg-primary text-primary-foreground" : "text-muted-foreground hover:text-foreground"}`}>
        {i === "monthly" ? "Monthly" : "Yearly · 2 months free"}
      </button>
    ))}
  </div>
);

export const PricingPlans = ({ interval, onSelect, current, busy, paypal }) => (
  <div className="grid gap-5 md:grid-cols-2 xl:grid-cols-4" data-testid="pricing-plans">
    {PLAN_CARDS.map((p) => (
      <div key={p.key} data-testid={`plan-card-${p.key}`}
        className={`relative rounded-2xl border p-7 flex flex-col lift ${p.popular ? "border-emerald-500/60 bg-gradient-to-b from-emerald-500/[0.07] to-transparent shadow-[0_0_40px_-12px_rgba(16,185,129,.45)] xl:-translate-y-2" : "border-border bg-card"}`}>
        {p.popular && (
          <span className="absolute -top-3 left-7 rounded-full bg-emerald-500 text-white text-[11px] font-bold uppercase tracking-wider px-3 py-1" data-testid="most-popular-badge">
            Most Popular · Recommended
          </span>
        )}
        <h3 className="text-xl font-bold">{p.name}</h3>
        <p className="text-sm text-muted-foreground mt-1 min-h-[40px]">{p.blurb}</p>
        <div className="mt-5 mb-6">
          {p.custom ? (
            <span className="text-3xl font-bold font-display">Custom</span>
          ) : (
            <>
              <span className="text-4xl font-bold font-mono">${interval === "yearly" ? p.yearly : p.monthly}</span>
              <span className="text-sm text-muted-foreground">/{interval === "yearly" ? "year" : "month"} USD</span>
            </>
          )}
        </div>
        <ul className="space-y-2.5 text-sm flex-1">
          {p.features.map((f) => (
            <li key={f} className="flex gap-2"><Check className="h-4 w-4 text-emerald-500 mt-0.5 shrink-0" />{f}</li>
          ))}
        </ul>
        <Button className={`mt-7 w-full ${p.popular ? "bg-emerald-600 hover:bg-emerald-500 text-white" : ""}`} variant={p.popular ? "default" : "outline"}
          disabled={busy === p.key || current === p.key} onClick={() => onSelect(p.key)} data-testid={`select-plan-${p.key}`}>
          {busy === p.key && <Loader2 className="h-4 w-4 mr-2 animate-spin" />}
          {current === p.key ? "Current plan" : p.custom ? "Contact sales" : `Choose ${p.name}`}
        </Button>
        {paypal && !p.custom && current !== p.key && (
          <button type="button" disabled={!!busy} onClick={() => onSelect(p.key, "paypal")} data-testid={`select-plan-${p.key}-paypal`}
            className="mt-2 w-full rounded-md border border-[#FFC439]/60 bg-[#FFC439] py-2 text-sm font-semibold text-[#003087] transition-colors hover:bg-[#F2BA36] disabled:opacity-60">
            Pay with <span className="italic font-bold">Pay</span><span className="italic font-bold text-[#009CDE]">Pal</span>
          </button>
        )}
      </div>
    ))}
  </div>
);
